/** SharePoint tenant host used for job sites and Estimates libraries. */
export const SHAREPOINT_HOST = 'https://laframboisegrpltd.sharepoint.com';

/**
 * Turn a stored SharePoint link into a browser-safe absolute href.
 * Awarded-job crawler historically stored server-relative paths like "/sites/75998",
 * which the browser would open on the portal origin instead of SharePoint.
 */
export function toSharePointHref(url) {
  const raw = String(url || '').trim();
  if (!raw) return null;
  if (/^https?:\/\//i.test(raw)) return raw;
  if (raw.startsWith('/')) return `${SHAREPOINT_HOST}${raw}`;
  return raw;
}
